import { defineStore } from 'pinia'

import { createCustomersActions } from './actions'
import { createCustomersState } from './state'

export const useCustomersStore = defineStore('customers', () => {
    const state = createCustomersState()
    const actions = createCustomersActions(state)

    return {
        ...state,
        ...actions
    }
})
